
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor">
	<path
		d="M15 26.25C8.78719 26.25 3.75 21.2128 3.75 15C3.75 8.78719 8.78719 3.75 15 3.75C21.2128 3.75 26.25 8.78719 26.25 15C26.25 21.2128 21.2128 26.25 15 26.25ZM15 1.875C7.7625 1.875 1.875 7.7625 1.875 15C1.875 22.2375 7.7625 28.125 15 28.125C22.2375 28.125 28.125 22.2375 28.125 15C28.125 7.7625 22.2375 1.875 15 1.875Z"
		fill="currentColor" />
	<path
		d="M19.4934 9.18164L15 13.6751L10.5065 9.18164L9.18091 10.5073L13.6743 15.0007L9.18091 19.4941L10.5065 20.8198L15 16.3263L19.4934 20.8198L20.819 19.4941L16.3256 15.0007L20.819 10.5073L19.4934 9.18164Z"
		fill="currentColor" />
</svg>
    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'CloseCircleLight',
    }) as DefineComponent
    </script>
    